import {Component, ElementRef, ViewChild} from '@angular/core';
import {ImageCroppedEvent, ImageCropperComponent, ImageTransform} from 'ngx-image-cropper';
import {ActivatedRoute} from '@angular/router';
import {MatDialogRef} from '@angular/material/dialog';
import {lastValueFrom} from 'rxjs';
import {ImageUploadService} from '@shared-services/image-upload.service';
import {ImageUploadUtilsService} from '@shared-services/image-upload-utils.service';
import {User} from "@ui-kit/framework/security/model/user.model";
import {ConsoleContextService} from "@security/console-context.service";

@Component({
  selector: 'app-upload-user-profile-image',
  templateUrl: './upload-user-profile-image.component.html',
  styleUrls: ['./upload-user-profile-image.component.scss']
})
export class UploadUserProfileImageComponent {
  @ViewChild(ImageCropperComponent) imageCropper!: ImageCropperComponent;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  imageChangedEvent: any = '';
  croppedImage: any = '';
  scale = 1;
  transform: ImageTransform = {};
  fileName: string;
  route = this.activatedRoute.snapshot;
  routeParam = true;
  aspectRatio: number;
  cropWidth: number;
  width?: string;
  round: boolean = true;
  image: any;
  loading = false;
  url?: string | ArrayBuffer;
  errorMessage: string | null = null;


  constructor(private dialogRef: MatDialogRef<UploadUserProfileImageComponent>,
              private activatedRoute: ActivatedRoute,
              private service: ImageUploadService,
              private context: ConsoleContextService,
              private imageUploadUtils: ImageUploadUtilsService) {
    this.fileName = 'no file selected';
    this.aspectRatio = 1;
    this.cropWidth = 200;
    this.round = true;
  }

  fileChangeEvent($event: Event): void {
    this.errorMessage = null;
    this.fileName = this.fileInput.nativeElement.value.replace(/^.*[\\\/]/, '');
    this.imageChangedEvent = $event;
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64;
  }

  imageLoaded(image?: HTMLImageElement): void {
    console.log(image);
    // show cropper
  }

  cropperReady(): void {
    // cropper ready
  }

  loadImageFailed(): void {
    // show message
    this.errorMessage = 'Invalid image type, only png and jpg are allowed';
  }

  onZoom(amount: number): void {
    console.log(this.scale);
    if ((amount > 0) && (this.scale < 2)) {
      this.scale = this.scale + 0.1;
    } else if ((amount < 0) && (this.scale >= 0.5)) {
      this.scale = this.scale - 0.1;
    }
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  upload(): void {
    this.errorMessage = null;
    const blob = this.imageUploadUtils.dataURItoBlob(this.croppedImage);
    if (blob.size > 10485760) {
      this.errorMessage = 'File size too large, files must be less than 10MB';
      return;
    }

    const type = this.fileName.replace(/^.+[\W]/, '');
    const file = new File([blob], this.fileName, {
      type: `image/${type}`
    });

    this.loading = true;
    lastValueFrom(this.service.save(file))
      .then((res: User) => {
        this.context.currentUser = res;
        this.close();
      }, error => {
        console.log(error);
        this.loading = false;
      });
  }

  close() {
    this.dialogRef.close();
  }
}
